import React from "react";
import styled from "styled-components";
import { UISref } from "@uirouter/react";
import { Helmet } from "react-helmet-async";

import PortletWrapper from "../misc/PortletWrapper";
import MarginWrapper from "../misc/MarginWrapper";
import TextHeader from "../misc/TextHeader";
import IndexList from "./IndexList";
import SearchByZip from "./SearchByZip";
import UseMyCurrentLocation from "./UseMyCurrentLocation";
import IndexMap from "./IndexMap";

const Wrapper = styled(MarginWrapper)`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    min-height: 350px;
`;

const LeftCol = styled.div`
    flex: 6;
`;

const MoreLocationsWrapper = styled.div`
    padding-bottom: 25px;
    display: block;
`;

const RightCol = styled.div`
    flex: 6;
    display: flex;
    flex-direction: column;
    min-width: 350px;
    @media (max-width: 737px) {
        min-width: 100%;
    }
`;

const RightColItemWrapper = styled.div`
    margin-bottom: 10px;
`;

// weirdly, height: 100% seems necessary for chrome
const MapWrapper = styled.div`
    flex-grow: 1;
    height: 100%;
    min-height: 350px;
    @media (max-width: 737px) {
        height: 350px;
    }
`;

const getTitle = regionState =>
    regionState
        ? `Branch locations in ${regionState.toUpperCase()}`
        : "Branch Locations";

const Index = ({
    regionState,
    ungroupedLocations,
    manyItemStates,
    fewItemStates,
    searchByZip,
    showingAll,
    jumpToLocation,
    jumpToCurrentLocation,
    jumpToCurrentLocationError,
    geographicCenter
}) => (
    <PortletWrapper>
        <Helmet>
            <title>{getTitle(regionState)}</title>
            <meta
                property="og:title"
                content={getTitle(regionState)}
            />
            <meta property="og:url" content={window.location.href} />
            <meta property="og:description" content="" />
        </Helmet>

        <TextHeader
            heading="Locations"
            subHeading="Choose a branch from the list or select a location on the map."
        />
        <Wrapper>
            <LeftCol>
                <IndexList
                    manyItemStates={manyItemStates}
                    fewItemStates={fewItemStates}
                />
                {!showingAll && (
                    <MoreLocationsWrapper>
                        <UISref to="home">
                            <a>More locations</a>
                        </UISref>
                    </MoreLocationsWrapper>
                )}
            </LeftCol>
            <RightCol>
                <RightColItemWrapper>
                    <SearchByZip searchByZip={searchByZip} />
                </RightColItemWrapper>
                {jumpToCurrentLocationError && (
                    <RightColItemWrapper
                        className="alert alert-danger alert-dismissible"
                        role="alert"
                    >
                        {jumpToCurrentLocationError}
                    </RightColItemWrapper>
                )}
                <RightColItemWrapper>
                    <UseMyCurrentLocation
                        showingAll={showingAll}
                        jumpToCurrentLocation={jumpToCurrentLocation}
                    />
                </RightColItemWrapper>
                <MapWrapper>
                    <IndexMap
                        locations={ungroupedLocations}
                        jumpToLocation={jumpToLocation}
                        geographicCenter={geographicCenter}
                    />
                </MapWrapper>
            </RightCol>
        </Wrapper>
    </PortletWrapper>
);

export default Index;



// WEBPACK FOOTER //
// ./components/index/Index.jsx